import React, {useEffect, useRef, useState} from "react";
import {Link, useLocation, useNavigate} from "react-router-dom";
import "./Header.css";
import {useTranslation} from "react-i18next";
import PopupLogin from "../../popuplogin/PopupLogin";
import geoflag from "./geoflag.png";
import gbflag from "./gbflag.png";
import {jwtDecode} from "jwt-decode";
import {FaUser} from "react-icons/fa";
import {RiLogoutBoxRLine} from "react-icons/ri";
import {AiFillHome} from "react-icons/ai";
import {Tooltip} from "@mui/material";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faShareFromSquare} from "@fortawesome/free-solid-svg-icons";
import AccountSettingsPopup from "./AccountSettingsPopup";
import {BiSolidMessageDetail} from "react-icons/bi";
import ChatComponent from "./ChatComponent";
import axios from "axios";
import {MdWarning} from "react-icons/md";
import departmentEnums from "../../../enums/departmentEnums";
import Topbar from "../../../dashboard/components/sidebar/Topbar";

const getUserDepartmentRole = () => {
    const token = localStorage.getItem('jwtToken');
    if (token) {
        try {
            const decodedToken = jwtDecode(token);
            return decodedToken.DepartmentId || null;
        } catch (error) {
            return null;
        }
    }
    return null;
};

const Header = () => {
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const location = useLocation();
    const [roleId, setRoleId] = useState("");
    const [userId, setUserId] = useState("");
    const [hasJWTToken, setHasJWTToken] = useState(false);
    const [hasSecondJWTToken, setSecondHasJWTToken] = useState(false);
    const {t, i18n} = useTranslation();
    const navigate = useNavigate();
    const [isAccountPopupOpen, setIsAccountPopupOpen] = useState(false);
    const buttonRef = useRef(null);
    const [popupStyle, setPopupStyle] = useState({});
    const [isChatOpen, setIsChatOpen] = useState(false);
    const [unseenMessagesCount, setUnseenMessagesCount] = useState(0);
    const [isHeaderExpanded, setIsHeaderExpanded] = useState(false);
    const [userData, setUserData] = useState(null);
    const [canSeeServices, setCanSeeServices] = useState(false);
    const token = localStorage.getItem("jwtToken");
    const userDepartment = getUserDepartmentRole();
    const [isBuildingDepartment, setIsBuildingDepartment] = useState(false);
    const showTesting = false;
    const lang = localStorage.getItem("lang")
    const isMobile = window.innerWidth < 768;

    useEffect(() => {
        setCanSeeServices((roleId && roleId === "USER") || roleId === '' || roleId === null)
    }, [roleId, token, localStorage]);

    useEffect(() => {
        if (userDepartment && parseInt(userDepartment) === departmentEnums.building.id) {
            setIsBuildingDepartment(true)
        } else {
            setIsBuildingDepartment(false)
        }
    }, [userDepartment, token]);

    useEffect(() => {
        const fetchUserData = async () => {
            if (userId && token) {
                try {
                    const response = await axios.get(
                        `${process.env.REACT_APP_API_BASE_URL}/User/GetOneUserByID?UserID=${userId}`
                    );
                    if (response.data.success) {

                        if (response.data.data.firstName === " ") {
                            setUserData(response.data.data.orgName)
                        } else {
                            setUserData(response.data.data.firstName + " " + response.data.data.lastName);
                        }
                    } else {
                        setUserData("ჩემი პროფილი");
                    }
                } catch (error) {
                    setUserData("ჩემი პროფილი");
                }
            }
        };

        void fetchUserData();
    }, [userId, token]);


    const handleUnseenMessagesCountUpdate = (count) => {
        setUnseenMessagesCount(count);
    };

    const handleOpenChat = () => {
        setIsChatOpen(true);
    };

    const handleCloseChat = () => {
        setIsChatOpen(false);
    };

    const openAccountPopup = () => {
        const rect = buttonRef.current.getBoundingClientRect();
        const top = rect.bottom + window.scrollY + 25;
        const left = rect.left + window.scrollX + rect.width / 2;
        setPopupStyle({top, left});
        setIsAccountPopupOpen(true);
    };
    const closeAccountPopup = () => {
        setIsAccountPopupOpen(false);
    };

    const checkTokenExpiration = () => {
        const expirationTime = localStorage.getItem("tokenExpiredTime");
        const currentTime = new Date();
        if (expirationTime) {
            const expirationDate = new Date(expirationTime);
            if (currentTime > expirationDate) {
                for (let i = localStorage.length - 1; i >= 0; i--) {
                    const key = localStorage.key(i);
                    if (key && key.includes("jwtToken")) {
                        localStorage.removeItem(key);
                    }
                }
                localStorage.removeItem("tokenExpiredTime");
                return true;
            }
        }
        return false;
    };

    useEffect(() => {
        if (checkTokenExpiration()) {
            localStorage.removeItem("jwtToken");
            navigate("/");
            setHasJWTToken(false);
            setSecondHasJWTToken(false);
        }
    }, [location]);

    useEffect(() => {

        if (token) {
            try {
                const decoded = jwtDecode(token);
                setRoleId(decoded.role);
                setUserId(decoded.UserId);
            } catch (error) {
                setRoleId("");
            }
        }
    }, [token]);

    useEffect(() => {
        setHasJWTToken(!!localStorage.getItem("jwtToken"));
        setSecondHasJWTToken(
            !!localStorage.getItem("1_jwtToken") ||
            !!localStorage.getItem("2_jwtToken") ||
            !!localStorage.getItem("3_jwtToken")
        );
    }, [hasJWTToken, token]);

    const handleLogout = () => {
        for (let i = localStorage.length - 1; i >= 0; i--) {
            const key = localStorage.key(i);
            if (key && key.includes("jwtToken")) {
                localStorage.removeItem(key);
            }
        }
        navigate("/");
        setHasJWTToken(false);
        setSecondHasJWTToken(false);
        setIsHeaderExpanded(false); // Revert header on logout
    };

    const openProfileSettings = () => {
        navigate("/dashboard/profile");
    };
    let destinationPath;
    switch (roleId) {
        case "ROOTADMIN":
            destinationPath = "/dashboard/pagemanager";
            break;

        default:
            destinationPath = "/dashboard/home";
            break;
    }

    const openPortal = () => {
        navigate(destinationPath);
        i18n.changeLanguage("geo");
    };


    const togglePopup = () => {
        setIsPopupOpen(!isPopupOpen);

        // If closing the popup, revert the header styles
        if (isPopupOpen) {
            setIsHeaderExpanded(false); // Revert header styles when popup is closed
        } else if (
            (location.pathname.includes("interactivemap") ||
                location.pathname.includes("map")) &&
            !isPopupOpen // Only expand if the popup is being opened
        ) {
            setIsHeaderExpanded(true); // Expand the header
        }
    };
    useEffect(() => {
        if (lang) {
            i18n.changeLanguage(lang)
        }
    }, [lang]);

    const toggleLanguage = () => {
        const newLang = i18n.language === "geo" ? "eng" : "geo";
        localStorage.setItem("lang", newLang)
        i18n.changeLanguage(newLang);
    };

    const scrollToBottom = () => {
        window.scrollTo({top: document.body.scrollHeight, behavior: "smooth"});
    };
    const isEnglish = i18n.language === "eng";


    return (
        <div>
            {location.pathname.includes("map") === false && showTesting && (
                <div
                    style={{
                        width: "100%",
                        backgroundColor: "red",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "60px",
                        color: "white",
                        fontFamily: "FiraGO-SemiBold",
                        margin: 0,
                        position: "fixed",
                        top: 0,
                        left: 0,
                        zIndex: 20,
                        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.3)",
                    }}
                >
                    <MdWarning style={{marginRight: '10px', fontSize: '24px'}}/>
                    {t("testing")}

                </div>
            )}

            <div
                className="header"
                style={{
                    ...(location.pathname.includes("interactivemap") ||
                    location.pathname.includes("map")
                        ? {
                            background: "transparent",
                            backdropFilter: "blur(30px)",
                            borderRadius: "0px",
                            position: "absolute",
                            zIndex: "2",
                            color: "white !important",
                            marginTop: 0
                        }
                        : {
                            marginTop: showTesting ? 60 : 0
                        }),
                    ...(isHeaderExpanded
                        && {
                            height: "100vh",
                            zIndex: "10000",
                            transition: "none",
                        }),
                }}
            >

                {isAccountPopupOpen && (
                    <AccountSettingsPopup
                        onClose={() => setIsAccountPopupOpen(false)}
                        style={popupStyle}
                    />
                )}
                <ChatComponent
                    open={isChatOpen}
                    onClose={handleCloseChat}
                    onUnseenMessagesCountUpdate={handleUnseenMessagesCountUpdate}
                />
                <Link
                    to="/"
                    className="header-logo-link"

                >
                    <img
                        src={process.env.PUBLIC_URL + "/headerdata/tacsa_logo.svg"}
                        alt="Logo"
                        className={`header-logo ${
                            location.pathname.includes("interactivemap") ||
                            location.pathname.includes("map")
                                ? "no-background-hover"
                                : ""
                        }`}
                    />
                </Link>
                <div
                    className="header-logo-container"
                    style={
                        location.pathname.includes("interactivemap") ||
                        location.pathname.includes("map")
                            ? {
                                color: "white !important",
                            }
                            : {
                                paddingLeft: (isBuildingDepartment && location.pathname.includes("dashboard")) ? 80 : 0
                            }

                    }
                >
                    <>
                        <Link
                            to="/"
                            className={`header-link ${
                                location.pathname === "/" ? "active" : "inactive"
                            }`}
                            style={
                                location.pathname.includes("interactivemap") ||
                                location.pathname.includes("map")
                                    ? {color: "white"} // Set color to white for interactivemap or map
                                    : location.pathname === "/"
                                        ? {color: "black"} // Set your active color here for "/objectregistry"
                                        : {color: "#4f4d4d"} // Set inactive color for other routes
                            }
                        >
                            {t("მთავარი")}
                        </Link>
                        {canSeeServices && (
                            <Link
                                to="/services"
                                className={`header-link ${
                                    location.pathname === "/services" ? "active" : "inactive"
                                }`}
                                style={
                                    location.pathname.includes("interactivemap") ||
                                    location.pathname.includes("map")
                                        ? {color: "white"} // Set color to white for interactivemap or map
                                        : location.pathname === "/services"
                                            ? {color: "black"} // Set your active color here for "/objectregistry"
                                            : {color: "#4f4d4d"} // Set inactive color for other routes
                                }
                            >
                                {t("სერვისები")}
                            </Link>
                        )}

                        <Link
                            to="/agencyanswers"
                            className={`header-link ${
                                location.pathname === "/agencyanswers" ? "active" : "inactive"
                            }`}
                            style={
                                location.pathname.includes("interactivemap") ||
                                location.pathname.includes("map")
                                    ? {color: "white"} // Set color to white for interactivemap or map
                                    : location.pathname === "/agencyanswers"
                                        ? {color: "black"} // Set your active color here for "/objectregistry"
                                        : {color: "#4f4d4d"} // Set inactive color for other routes
                            }
                        >
                            {t("სააგენტოს პასუხები")}
                        </Link>
                        {!isBuildingDepartment && (
                            <Link
                                to={hasJWTToken ? "/dashboard/registery" : "/objectregistry"}
                                className={`header-link ${
                                    location.pathname === "/objectregistry" ? "active" : "inactive"
                                }`}
                                style={
                                    location.pathname.includes("interactivemap") ||
                                    location.pathname.includes("map")
                                        ? {color: "white"} // Set color to white for interactivemap or map
                                        : location.pathname === "/objectregistry"
                                            ? {color: "black"} // Set your active color here for "/objectregistry"
                                            : {color: "#4f4d4d"} // Set inactive color for other routes
                                }
                            >
                                {t("უწყებრივი რეესტრი")}
                            </Link>
                        )}


                        {location.pathname.includes("/dashboard") ? null : (
                            <div
                                className={`contact-header`}
                                style={
                                    location.pathname.includes("interactivemap") ||
                                    location.pathname.includes("map")
                                        ? {display: "none"}
                                        : {} // Set color to white for interactivemap or map
                                }
                                onClick={scrollToBottom}
                            >
                                {t("კონტაქტი")}
                            </div>
                        )}
                    </>
                </div>
                {!hasJWTToken && (
                    //border: 1px solid black
                    <div
                        className="login-button"
                        style={
                            location.pathname.includes("interactivemap") ||
                            location.pathname.includes("map")
                                ? {border: "1px solid white"} // Apply border for specific paths
                                : {}
                        }
                        onClick={togglePopup}
                    >
                        <img
                            src={process.env.PUBLIC_URL + "/headerdata/person_icon.svg"}
                            alt="PersonIcon"
                            className="header-icon"
                            style={
                                location.pathname.includes("interactivemap") ||
                                location.pathname.includes("map")
                                    ? {
                                        filter:
                                            "invert(100%) sepia(0%) saturate(0%) hue-rotate(93deg) brightness(103%) contrast(103%)", // Removed extra semicolon
                                    }
                                    : {}
                            }
                        />
                        <span
                            className="header-button-text"
                            style={
                                location.pathname.includes("interactivemap") ||
                                location.pathname.includes("map")
                                    ? {color: "white"} // Apply color only for specific paths
                                    : {}
                            }
                        >
            {t("შესვლააა")} {/* Fixed the translation */}
          </span>
                    </div>
                )}
                {hasJWTToken && (
                    <div className="dashboard-header-right">
                        {roleId !== "USER" && roleId !== "ROOTADMIN" && (
                            <Tooltip title={"მიმოწერა"}>
                                <button className={"portal-button"} onClick={handleOpenChat}>
                                    <BiSolidMessageDetail style={{fontSize: 25}}/>
                                    {unseenMessagesCount > 0 && (
                                        <span className="unseen-messages-count">
                                            {unseenMessagesCount}
                                        </span>
                                    )}
                                </button>
                            </Tooltip>
                        )}

                        <Tooltip title={"პორტალის მთავარი გვერდი"}>
                            <button className={"portal-button"} onClick={openPortal}>
                                <AiFillHome style={{fontSize: 25}}/>
                            </button>
                        </Tooltip>
                        <Tooltip title={userData ? userData : "იტვირთება..."}>
                            <button className={"profile-button"} onClick={openProfileSettings}>
                                <FaUser style={{fontSize: 25}}/>
                            </button>
                        </Tooltip>
                        {hasSecondJWTToken && roleId !== "USER" && isAccountPopupOpen && (
                            <Tooltip title={"ანგარიშს შეცვლა"}>
                                <button
                                    ref={buttonRef}
                                    className={"profile-button"}
                                    onClick={() => closeAccountPopup()}
                                >
                                    <FontAwesomeIcon
                                        icon={faShareFromSquare}
                                        style={{fontSize: 22}}
                                    />
                                </button>
                            </Tooltip>
                        )}
                        {hasSecondJWTToken && roleId !== "USER" && !isAccountPopupOpen && (
                            <Tooltip title={"ანგარიშს შეცვლა"}>
                                <button
                                    ref={buttonRef}
                                    className={"profile-button"}
                                    onClick={() => openAccountPopup()}
                                >
                                    <FontAwesomeIcon
                                        icon={faShareFromSquare}
                                        style={{fontSize: 22}}
                                    />
                                </button>
                            </Tooltip>
                        )}

                        <Tooltip title={"გასვლა"}>
                            <button className={"logout-button"} onClick={handleLogout}>
                                <RiLogoutBoxRLine style={{fontSize: 28}}/>
                            </button>
                        </Tooltip>
                    </div>
                )}
                {location.pathname.includes("/dashboard") ? null : (
                    <>
                        {!isEnglish && (
                            <div className="header-lang-switcher-container">
                                <Tooltip title="Change Language to English">
                                    <div onClick={toggleLanguage} className="lang-switch">
                                        <img
                                            className="lang-image"
                                            alt="flag"
                                            src={geoflag}
                                        />
                                    </div>
                                </Tooltip>
                            </div>
                        )}
                        {isEnglish && (
                            <div className="header-lang-switcher-container">
                                <Tooltip title="პორატის ქართულ ენაზე გადართვა">
                                    <div onClick={toggleLanguage} className="lang-switch">
                                        <img
                                            className="lang-image"
                                            src={gbflag}
                                            alt="logo"
                                        />
                                    </div>
                                </Tooltip>
                            </div>
                        )}
                    </>
                )}
                {location.pathname.includes("/dashboard") && isMobile && (
                    <Topbar/>
                )}
                {isPopupOpen && (
                    <PopupLogin isOpened={isPopupOpen} onClose={togglePopup}/>
                )}
            </div>
        </div>
    );
};

export default Header;
